import type { ReactNode } from 'react';

export function Empty({
  title,
  body,
  action,
}: {
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="surface py-14 px-8 text-center max-w-2xl mx-auto">
      <h3 className="font-display text-xl tracking-snug">{title}</h3>
      {body ? (
        <p className="mt-2 text-graphite text-[15px] max-w-md mx-auto leading-relaxed">{body}</p>
      ) : null}
      {action ? <div className="mt-5 flex justify-center">{action}</div> : null}
    </div>
  );
}
